import { Navigate, Outlet } from "react-router";
import { useAuthSessionQuery } from "../../utils/useAuthSessionQuery";

export default function PublicOnlyRoute() {
  const { data } = useAuthSessionQuery();

  if (data?.isAuthenticated) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
}
